// import Modal from "components/modal/modal";
import { Button, Dialog } from "@mui/material"
import { LayerInfoModal } from "helpers/constants";
import { AppAction, AppContext } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./info-modal.module.scss";

function InfoModal() {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();

  const title = (): string => {
    if (context.layerInfoModal) {
      return context.layerInfoModal.name
    }
    return "";
  };

  const text = (): string => {
    if (context.layerInfoModal) {
      return context.layerInfoModal.description
    }
    return "";
  };



  const close = (): void => {
    dispatch({
      type: AppAction.setLayerInfoModal,
      payload: undefined,
    });
  };

  return (
    <Dialog
      open={(context.layerInfoModal ? true : false)}
      onClose={close}
      sx={{
        "& .MuiDialog-paper": {
          width: "600px",
          maxWidth: "80vw",
          maxHeight: "85vh",
          borderRadius: "4px"
        }
      }}
    >
      <div className={styles.container}>
        <div className={styles.header}>{title()}</div>
        <div className="form-control">
            <div className={styles.text}>{text()}</div>
            <div className={styles.button}>
              <Button onClick={close} color="success">{t("buttons.close")}</Button>
            </div>
        </div>
      </div>
    </Dialog>
  );
}

export default InfoModal;
